import React from 'react';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/FormSubmitButton';
import PreviousSubmitBtn from '../../../components/Button/PreviousSubmitBtn';
import {
  CustomCheckbox,
  CustomCheckboxGroup,
} from '../../../components/FormCom/CustomCheckBoxField';
import CustomSearchableSelectField from '../../../components/FormCom/CustomSearchableSelectField';
import CustomSelectField from '../../../components/FormCom/CustomSelectField';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import { TranslatingContainerContext } from '../../../components/TranslatingContainer/TranslatingContainerProvider';
import {
  SignUpMoreInfoDataType,
  signUpMoreInfoInitialValues,
  SignUpMoreInfoSchema,
} from '../../../models/auth/signUp/signUpMoreInfo.model';
import { signUpActions } from '../../../redux/slices/signUpSlice';
import { useAppDisPatch } from '../../../redux/store';
import { listOfIndustries } from './SignUpData';

// const typicalRouteOptions: Record<string, string> = {
//   Intrastate: 'Intrastate',
//   Interstate: 'Interstate',
//   Rural: 'Rural',
//   'Long Haul': 'LongHaul',
// };

const fleetSize: Record<string, string> = {
  'Less than 10': '0 - 10',
  '10 - 50': '10 - 50',
  '50 - 100': '50 - 100',
  '100 - 500': '100 - 500',
  'Above 500': '500+',
};

const SignUpMoreInfoForm = () => {
  const dispatch = useAppDisPatch();
  const { sliderIndex, setSliderIndexPos } = React.useContext(
    TranslatingContainerContext,
  )!;

  const onSubmit = (value: SignUpMoreInfoDataType) => {
    dispatch(
      signUpActions.setMoreInfoSlider({
        ...value,
        fleetSize: fleetSize[value.fleetSize],
      }),
    );
    setSliderIndexPos(1);
  };

  return (
    <Container sliderIndex={sliderIndex}>
      <FormComponent
        initialValues={signUpMoreInfoInitialValues}
        schema={SignUpMoreInfoSchema}
        onSubmit={onSubmit}
      >
        {/* <CustomSelectField */}
        <CustomSearchableSelectField
          label='Industry Type'
          placeholder='Select...'
          name='industryType'
          id='industryType'
          optionData={listOfIndustries}
        />
        <CustomSelectField
          label='Fleet Size'
          placeholder='Select...'
          name='fleetSize'
          id='fleetSize'
          optionData={Object.keys(fleetSize)}
        />

        <CustomCheckboxGroup
          label='Typical Route'
          name='typicalRoute'
          className='row-group slim-error'
        >
          <CustomCheckbox value='Intrastate'>Intrastate</CustomCheckbox>
          <CustomCheckbox value='Interstate'>Interstate</CustomCheckbox>
          <CustomCheckbox value='Rural'>Rural</CustomCheckbox>
          <CustomCheckbox value='Long Haul'>Long Haul</CustomCheckbox>
        </CustomCheckboxGroup>

        {/* <RadioLabel>Delivery Vehicle Type</RadioLabel> */}
        <CustomCheckboxGroup
          label='Delivery Vehicle Type'
          name='deliveryVehicleTypes'
          className='row-group slim-error'
        >
          <CustomCheckbox value='Keke'>Auto-rickshaw (Keke)</CustomCheckbox>
          <CustomCheckbox value='Trailer'>Trailer</CustomCheckbox>
          <CustomCheckbox value='Bus'>Bus</CustomCheckbox>
          <CustomCheckbox value='Bicycle'>Bicycle</CustomCheckbox>
          <CustomCheckbox value='Van'>Van</CustomCheckbox>
          <CustomCheckbox value='Bike'>Bike</CustomCheckbox>
          <CustomCheckbox value='Car'>Car</CustomCheckbox>
          <CustomCheckbox value='Tanker'>Tanker</CustomCheckbox>
          <CustomCheckbox value='Truck'>Truck</CustomCheckbox>
        </CustomCheckboxGroup>

        <FormButtonArea>
          <PreviousSubmitBtn>Go Back</PreviousSubmitBtn>
          <FormSubmitButton className='large'>Next</FormSubmitButton>
        </FormButtonArea>
      </FormComponent>
    </Container>
  );
};

export default SignUpMoreInfoForm;

interface ContainerProp {
  sliderIndex: number;
}

const Container = styled.div<ContainerProp>`
  flex-direction: column;
  display: ${({ sliderIndex }) => (sliderIndex >= 2 ? 'flex' : 'none')};
`;

const FormButtonArea = styled.div`
  /* z-index: -1; */
  display: grid;
  grid-template-columns: 120px auto;
  gap: 24px;
  margin-top: 12px;
`;

// const RadioLabel = styled.label`
//   display: flex;
//   font-size: 14px;
//   font-weight: 600;
//   margin-bottom: -8px;
// `;
